/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants";

export default class Rabbit
{
  constructor(scene, x, y)
  {
    this.scene = scene;

    this.shadow = this.scene.add.sprite(x, y + 5, CONSTANTS.ATLAS_KEY, "rabbit/run/shadow.png");
    this.sprite = this.scene.physics.add.sprite(x, y, CONSTANTS.ATLAS_KEY, "rabbit/run/0006.png");
    // error correction for collision
    // alternative: http://phaser.io/examples/v2/p2-physics/body-debug (phaser2)
    this.sprite.body.setSize(this.sprite.width * 0.70, this.sprite.height * 0.85, true);
    this.sprite.setBounce(0);
    this.sprite.setCollideWorldBounds(true);
    this.sprite.body.setImmovable(true);

    this.powerUpActive = null;

    this.powerUp = null;

    this.alive = true;
    this.jumping = false;

    this.flashTween = null;
  }

  destroy()
  {
    this.shadow.destroy();
    this.sprite.destroy();

    if(this.powerUpActive !== null)
    {
      this.powerUpActive.destroy();
    }
  }

  startRunning()
  {
    if(this.isTouchingGround())
    {
      this.jumping = false;
      this.shadow.setFrame("rabbit/run/shadow.png");

      if(this.powerUp !== null && this.powerUp.type === "rocket-cake")
      {
        this.sprite.anims.play("rabbit-rocket-run", true);
      }
      else
      {
        this.sprite.anims.play("rabbit-run", true);
      }
    }
  }

  stopRunning()
  {
    this.sprite.anims.play("rabbit-idle", true);
  }

  jump()
  {
    var jumpOptions = this.getJumpOptions();



    this.jumping = true;
    this.shadow.setFrame("rabbit/jump/up_shadow.png");
    this.sprite.anims.play(jumpOptions.jumpAnimation, true);
    this.sprite.setVelocityY(jumpOptions.velocity);
  }

  fall()
  {
    var jumpOptions = this.getJumpOptions();

    this.shadow.setFrame("rabbit/jump/down_shadow.png");
    this.sprite.anims.play(jumpOptions.fallAnimation, true);
  }

  isFalling()
  {
    return this.sprite.body.velocity.y > 0 && this.jumping;
  }

  updateShadow()
  {
    // maybe scale shadow (doesn't look good rn)
  }

  isTouchingGround()
  {
    // or this.sprite.body.onFloor();
    return this.sprite.body.blocked.down;
  }

  givePowerUp(powerUp)
  {
    if(powerUp)
    {
      this.powerUp = powerUp;

      if(this.jumping)
      {
        var jumpOptions = this.getJumpOptions();

        if(this.isFalling())
        {
          this.sprite.anims.play(jumpOptions.fallAnimation, true);
        }
        else
        {
          this.sprite.anims.play(jumpOptions.jumpAnimation, true);
        }
      }
      else
      {
        this.startRunning();
      }

      if(this.powerUp.activeTexture)
      {
        this.powerUpActive = this.scene.add.sprite(this.sprite.x + this.powerUp.activeTexture.offset.x, this.sprite.y + this.powerUp.activeTexture.offset.y, this.powerUp.activeTexture.key, this.powerUp.activeTexture.frame);
        this.powerUpActive.setDepth(89);
      }

      var that = this;

      this.scene.time.delayedCall(this.powerUp.duration - 5000, () =>
      {
        var tween = that.scene.tweens.addCounter({
          from: 0,
          to: 100,
          loop: 10,
          duration: 500,
          onUpdate: function()
          {
            if(that.powerUp !== null)
            {
              if(that.powerUpActive !== null)
              {
                that.powerUpActive.setVisible(tween.getValue() > 50);
              }
              else
              {
                that.sprite.setVisible(tween.getValue() > 50);
              }
            }
          }
        });
      });
    }
  }

  removePowerUp()
  {
    if(this.powerUp)
    {
      if(this.powerUpActive !== null)
      {
        this.powerUpActive.destroy();
        this.powerUpActive = null;
      }

      this.powerUp = null;
    }
  }

  attractPowerUp()
  {
    if(this.powerUp !== null && this.powerUp.activeTexture)
    {
      this.powerUpActive.setPosition(this.sprite.x + this.powerUp.activeTexture.offset.x, this.sprite.y + this.powerUp.activeTexture.offset.y);
    }
  }

  hasRocketCake()
  {
    return typeof this.powerUp !== "undefined" && this.powerUp !== null && this.powerUp.type === "rocket-cake";
  }

  flash()
  {
    var startColor = Phaser.Display.Color.HexStringToColor("#ff0000"),
        endColor = Phaser.Display.Color.HexStringToColor("#ffffff");

    if(this.flashTween !== null && this.flashTween.isPlaying())
    {
      // this.flashTween.stop();
      return;
    }

    var that = this;

    this.flashTween = this.scene.tweens.addCounter({
      from: 0,
      to: 100,
      loop: 1,
      duration: 200,
      onUpdate: function()
      {
        that.sprite.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(startColor, endColor, 100, that.flashTween.getValue())).color;
      },
      onComplete: function()
      {

      }
    });
  }

  getJumpOptions()
  {
    if(this.powerUp !== null)
    {
      /*if(this.powerUp.type === "springball")
      {
        return { jumpAnimation: "rabbit-springball-jumping", fallAnimation: "rabbit-springball-falling", velocity: -350 };
      }
      else */if(this.powerUp.type === "rocket-cake")
      {
        return { jumpAnimation: "rabbit-rocket-jumping", fallAnimation: "rabbit-rocket-falling", velocity: -525 };
      }
    }

    return { jumpAnimation: "rabbit-jumping", fallAnimation: "rabbit-falling", velocity: -525 };
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/objects/rabbit.js